import React, { useState, useEffect } from "react";
// @mui
import { useTheme } from "@mui/material";

function HeroSection({ white = false, zero = false }) {
  const theme = useTheme();

  return (
    <div style={{ background: white && theme.palette.background.paper }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28848.24675250927!2d55.362122!3d25.336746000000005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5ba91b3ed71d%3A0xa50e06877905e2e2!2sAl%20Saraya%20Bus%20Rental!5e0!3m2!1sen!2sae!4v1709892768376!5m2!1sen!2sae" 
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}

export default HeroSection;
